<template>
  <div>
    <div class="row">
      <div class="col-md-3 col-sm-6">
        <statistic-card-horizontal
          icon="ClockIcon"
          color="warning"
          :statistic="resumo.em_fila"
          statisticTitle="Na fila"
        />
      </div>
      <div class="col-md-3 col-sm-6">
        <statistic-card-horizontal
          icon="MessageSquareIcon"
          color="primary"
          :statistic="resumo.em_atendimento"
          statisticTitle="Em atendimento"
        />
      </div>
      <div class="col-md-3 col-sm-6">
        <statistic-card-horizontal
          icon="CheckCircleIcon"
          color="success"
          :statistic="resumo.encerrados_hoje"
          statisticTitle="Encerrados hoje"
        />
      </div>
      <div class="col-md-3 col-sm-6">
        <statistic-card-horizontal
          icon="TrendingUpIcon"
          color="info"
          :statistic="duracaoFormatada(resumo.tempo_medio_atendimento_segundos)"
          statisticTitle="Tempo médio de atendimento"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <b-card title="Por departamento">
          <b-table
            :items="resumo.por_departamento"
            :fields="[
              { key: 'departamento', label: 'Departamento' },
              { key: 'fila', label: 'Na fila' },
              { key: 'em_atendimento', label: 'Em atendimento' },
            ]"
            small
            responsive
            :empty-text="'Nada em aberto no momento'"
            show-empty
          />
        </b-card>
      </div>
      <div class="col-md-6">
        <b-card title="Por operador (em atendimento agora)">
          <b-table
            :items="resumo.por_operador"
            :fields="[
              { key: 'operador', label: 'Operador' },
              { key: 'em_atendimento', label: 'Em atendimento' },
            ]"
            small
            responsive
            :empty-text="'Ninguém com atendimento em aberto no momento'"
            show-empty
          />
        </b-card>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <b-card>
          <div class="d-flex align-items-center">
            <feather-icon icon="ClockIcon" size="24" class="mr-1 text-warning" />
            <div>
              <h4 class="mb-0">{{ duracaoFormatada(resumo.tempo_medio_espera_segundos) }}</h4>
              <small class="text-muted">Tempo médio de espera na fila hoje</small>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { BCard, BTable } from "bootstrap-vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";

export default {
  components: {
    BCard,
    BTable,
    FeatherIcon,
    StatisticCardHorizontal,
  },
  data() {
    return {
      intervalo: null,
      resumo: {
        em_fila: 0,
        em_atendimento: 0,
        encerrados_hoje: 0,
        tempo_medio_espera_segundos: 0,
        tempo_medio_atendimento_segundos: 0,
        por_departamento: [],
        por_operador: [],
      },
    };
  },
  methods: {
    carregarResumo() {
      window.axios
        .get(this.$store.state.api + "painel/resumo")
        .then((resposta) => {
          this.resumo = resposta.data;
        })
        .catch(() => {});
    },
    duracaoFormatada(segundos) {
      if (!segundos) return "00:00";
      const minutos = String(Math.floor(segundos / 60)).padStart(2, "0");
      const resto = String(segundos % 60).padStart(2, "0");
      return minutos + ":" + resto;
    },
  },
  mounted() {
    this.carregarResumo();
    this.intervalo = setInterval(this.carregarResumo, 30000);
  },
  beforeDestroy() {
    clearInterval(this.intervalo);
  },
};
</script>
